import cx from 'classnames';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {BillingPlatformSubscriptionStatus} from 'enums';
import {TRANSLATION_KEYS} from 'locale';
import {buildTranslationKey} from 'utils/transform';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.SUBSCRIPTION;

type Props = {
    status: BillingPlatformSubscriptionStatus;
    pauseScheduled?: boolean;
}

export const SubscriptionStatus: React.FC<Props> = ({status, pauseScheduled}) => {
    const {t} = useTranslation();
    const isActive = useMemo(() => status === BillingPlatformSubscriptionStatus.Active, [status]);
    const statusKey = useMemo(() => T_KEYS.STATUS[buildTranslationKey(status)], [status]);
    return (
        <div className={cx('tw-ts-h5-bold tw-px-2 tw-rounded-full', {
            'tw-bg-success tw-text-alternative': isActive && !pauseScheduled,
            'tw-bg-warning tw-text-alternative': isActive && pauseScheduled
        })}
        >
            {t(statusKey)}
        </div>
    );
};